import { useEffect } from 'react'
import { useCurrentOrganization } from '@/hooks/use-current-organization'
import { useToast } from '@/hooks/use-toast'
import { useTranslation } from '@/hooks/use-translation'
import { consumeOrganizationChangeNotice, getTabOrganizationId } from '@/lib/tab-organization'

/** Tells the user a link moved this tab to another client than the one it was showing. */
export function useTabOrganizationChangeNotice(): void {
  const { organization } = useCurrentOrganization()
  const { info } = useToast()
  const t = useTranslation()

  useEffect(() => {
    if (organization === null || organization.id !== getTabOrganizationId()) return
    if (!consumeOrganizationChangeNotice()) return
    info(t('sidebar.orgSwitcher.viewingOrganization', { name: organization.name }))
  }, [organization, info, t])
}
